import * as React from 'react';
import {StyleSheet, Text} from 'react-native';
import {Props} from './model';
import {useTheme} from '../../theme';

export default (props: React.PropsWithChildren<Props>) => {
  const theme = useTheme();
  const {color = theme.color.textColor, type = 'body', children, ref, ...rest} = props;
  const typeStyle = theme.fonts[type];

  rest.style = StyleSheet.compose({...typeStyle, color}, rest.style);

  return (
    <Text {...rest} ref={ref as unknown as React.LegacyRef<Text>}>
      {children}
    </Text>
  );
};
